import React, { useState, useEffect } from 'react';
import TR from '../../Trans';
import Button from '@mui/material/Button';
import BDialog from './BDialog';
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';
import CreatorsDialog from './CreatorsDialog';
import DialogContent from '@mui/material/DialogContent';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid';
import Select from '@mui/material/Select';
import MuvikaService from './../../services/muvika';
import IconButton from '@mui/material/IconButton';
import PitchButtons from '../items/PitchButtons';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import messageStore from './../../stores/message';
import songbookSessionStore from './../../stores/songbookSession';
import { Views } from './../../enums/enums';
import Link from '@mui/material/Link';
import searchStore from '../../stores/search';
import navigationStore from '../../stores/navigation';

function ChangeTrackPerformanceSongbook(props) {

  const sessionToken = songbookSessionStore((state) => state.sessionToken);
  const setError = messageStore((state) => state.setError);
  const session = songbookSessionStore((state) => state.session);

  const itemsOnPage = 25;
  const setSearchQuery = searchStore((state) => state.setSearchQuery);
  const goToView = navigationStore((state) => state.goToView);
  const search = searchStore((state) => state.search);
  const setOnlyArtist = searchStore((state) => state.setOnlyArtist);

  const getInitPitch = () => {
    if (props.track && props.performance && session.account.tags.includes("consumer")) {
      return props.track.last_pitch ? props.track.last_pitch : props.performance.pitch;
    }
    return 0;
  };

  const [currentPitch, setCurrentPitch] = useState(getInitPitch());
  const [creators, setCreators] = useState(null);

  useEffect(() => {
    if (props.open) {
      setCurrentPitch(getInitPitch());
    }
  }, [props.open]);

  useEffect(() => {
    getCreators();
  }, []);

  const getCreators = () => {
    if (props.track) {
      if (props.track.track_id) {
        MuvikaService.getTrackCreators(sessionToken, props.track.track_id)
          .then(function (res) {
            if (res.data.data) {
              if (res.data.error) {
                setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
              } else {
                setCreators(res.data.data.items);
              }
            }
          })
          .catch(function () { });
      }
    }
  };

  const [isCreatorsDialogOpen, setIsCreatorsDialogOpen] = useState(false);

  const handleOpenCreatorsDialog = () => {
    getCreators();
    setIsCreatorsDialogOpen(true);
  };

  const handleCloseCreatorsDialog = () => {
    setIsCreatorsDialogOpen(false);
  };

  const handlePitchChange = (event, newPitch) => {
    setCurrentPitch(newPitch);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      props.onChangeTrackPerformance(currentPitch);
    }
  };

  const handleSearchArtist = () => {
    props.onClose();
    setOnlyArtist();
    setSearchQuery(props.track.artist);
    search(sessionToken, itemsOnPage);
    goToView(Views.Search);
  };

  return (
    <BDialog disableRestoreFocus open={props.open} onKeyDown={handleKeyDown} onClose={props.onClose}>
      <CreatorsDialog open={isCreatorsDialogOpen} onClose={handleCloseCreatorsDialog} creators={creators} track={props.track} />
      <DialogContent>
        <img className="muvika-cover-image" src={props.track.url_cover_image} alt="" />
        <h4 className="muvika-track-title">
          <Link className="muvika-link-nodec" onClick={handleSearchArtist}>
            {props.track.artist}
          </Link> - {props.track.title} ({props.track.kcode})
          <IconButton color="white" component="label" onClick={handleOpenCreatorsDialog}>
            <InfoIcon />
          </IconButton>
        </h4>
        <Stack spacing={5}>
          <Paper className="muvika-pitch-buttons">
            <p className="muvika-pitch-title">
              {TR.cm_key_pitch}
            </p>
            <PitchButtons value={currentPitch} onPitchChange={handlePitchChange} />
          </Paper>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={6} justifyContent="center">
          <Button color="secondary" onClick={props.onClose}>{TR.cm_cancel}</Button>
          <Button
            color="success"
            className="muvika-dialog-action-right"
            onClick={() => props.onChangeTrackPerformance(currentPitch)}>{TR.cm_change}</Button>
        </Stack>
      </DialogActions>
    </BDialog>
  );
}

export default ChangeTrackPerformanceSongbook;